const STORAGE_PREFIX = 'pod-wizard:';
const TTL_MS = 24 * 60 * 60 * 1000;

export interface WizardProgress {
    step: number;
    confirmations: boolean[];
    timestamp: number;
}

export const saveWizardProgress = (providerId: number, step: number, confirmations: boolean[]) => {
    try {
        const data: WizardProgress = { step, confirmations, timestamp: Date.now() };
        localStorage.setItem(STORAGE_PREFIX + providerId, JSON.stringify(data));
    } catch {
        // ignore quota/serialization errors
    }
};

export const loadWizardProgress = (providerId: number): WizardProgress | null => {
    try {
        const raw = localStorage.getItem(STORAGE_PREFIX + providerId);
        if (!raw) return null;
        const data = JSON.parse(raw) as WizardProgress;
        if (!data || typeof data.step !== 'number' || !Array.isArray(data.confirmations) || typeof data.timestamp !== 'number') {
            localStorage.removeItem(STORAGE_PREFIX + providerId);
            return null;
        }
        if (Date.now() - data.timestamp > TTL_MS) {
            localStorage.removeItem(STORAGE_PREFIX + providerId);
            return null;
        }
        return data;
    } catch {
        return null;
    }
};

export const clearWizardProgress = (providerId: number) => {
    try {
        localStorage.removeItem(STORAGE_PREFIX + providerId);
    } catch {
        // ignore
    }
};
